var React = require('react');

function ShieldInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.92 1.81337L5.58667 5.96004C4.62667 6.38671 4 7.34671 4 8.40004V14.6667C4 22.0667 9.12 28.9867 16 30.6667C22.88 28.9867 28 22.0667 28 14.6667V8.40004C28 7.34671 27.3733 6.38671 26.4133 5.96004L17.08 1.81337C16.4 1.50671 15.6 1.50671 14.92 1.81337V1.81337ZM12.3867 21.72L8.93333 18.2667C8.41333 17.7467 8.41333 16.9067 8.93333 16.3867C9.45333 15.8667 10.2933 15.8667 10.8133 16.3867L13.3333 18.8934L21.1733 11.0534C21.6933 10.5334 22.5333 10.5334 23.0533 11.0534C23.5733 11.5734 23.5733 12.4134 23.0533 12.9334L14.2667 21.72C13.76 22.24 12.9067 22.24 12.3867 21.72Z","fill":"#323232"}));
}

ShieldInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ShieldInline;

ShieldInline.default = ShieldInline;
